import { __awaiter, __generator } from "tslib";
import { m365AppDefinitionsBehaviorSubject } from '../state';
import { setupM365AppsConfigService } from '../utils';
/**
 * @description This method is used for get all M365 Application definitions in first load since current hook will return empty array first.
 * Will be deprecated after useAppDefinition hook finish rewriting.
 */
export var getAppDefinitionForAdminAcquiredApps = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, setupM365AppsConfigService()];
            case 1:
                _a.sent();
                return [2 /*return*/, m365AppDefinitionsBehaviorSubject.getValue()];
        }
    });
}); };
//# sourceMappingURL=getAppDefinitionForAdminAcquiredApps.js.map